var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/16px/Right-Arrow-Dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.83737663,3.16328971 C6.05420779,3.38251983 6.05420779,3.73906073 5.83737664,3.95829084 L2.806,7.019 L14.5,7.02 C14.7761424,7.02 15,7.24385763 15,7.52 C15,7.76545989 14.8231248,7.96960837 14.5898756,8.01194433 L14.5,8.02 L2.847,8.019 L5.83737664,11.0417092 C6.05420779,11.2609393 6.05420779,11.6174802 5.83737664,11.8367103 C5.62203949,12.0544299 5.2740644,12.0544299 5.05872726,11.8367103 L1.16262336,7.89750057 C0.945792212,7.67827045 0.945792212,7.32172955 1.16262336,7.10249944 L5.05872725,3.16328971 C5.2740644,2.9455701 5.62203949,2.9455701 5.83737663,3.16328971 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Right-Arrow-Dark",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D6DCE8",
    fillRule: "nonzero",
    transform: "translate(8.000000, 7.500000) scale(-1, 1) translate(-8.000000, -7.500000) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowDark);
export default __webpack_public_path__ + "static/media/Right-Arrow-Dark.944771cb7a1bb0c5c5fb8976b41c4a35.svg";
export { ForwardRef as ReactComponent };